import { Configuration, PopupRequest } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID as string,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
};

export const loginRequest: PopupRequest = {
  scopes: [process.env.REACT_APP_CLIENT_ID+'/.default'],
  // Enable refresh token by setting prompt to "none" for silent refresh
  extraScopesToConsent: ['offline_access'] // This enables refresh tokens
};

export const tokenRequest: PopupRequest = {
   scopes: [process.env.REACT_APP_CLIENT_ID+'/.default'],
};